import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import DocumentsTypesListView from "./documents_types-list.html";
import DocumentsTypesEditView from "./documents_types-edit.html";


angular.module("documents_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('documents_types', {
                url: "/documents_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('documents_types.list', {
                url: "/list",
                controller: "DocumentsTypesListCtrl",
                template: DocumentsTypesListView,
                params: { reset: null },
                data: { pageTitle: 'Tipos de documentos' }
            })
            .state('documents_types.edit', {
                url: "/edit/:id",
                controller: "DocumentsTypesEditCtrl",
                template: DocumentsTypesEditView,
                data: { pageTitle: 'Tipos de documentos' }
            })
            ;
    }])
    ;